import api from "@/axios/api";
import store from '@/vuex/store.js';
import { Toast } from "vant";
import * as types from './../vuex/types'
const appId = process.env.APP_ID

var token = {
    getCode() {
        let url = escape(window.location.href);
        console.log(url)
        window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" +
            url +
            "&response_type=code&scope=snsapi_base&state=&connect_redirect=1#wechat_redirect";
    },
    getToken() {
        let code = window.location.href.split("?code=")[1].split("#/")[0];
        let agentId = window.location.href.split("agentId=")[1];
        if (agentId.indexOf("&") != -1) {
            var agentNum = agentId.split("&")[0];
        } else {
            var agentNum = agentId
        }

        let par = {
            code: code,
            agentId: agentNum
        };

        api.getToken(par).then(res => {
            let token = res.token;
            if (token) {
                sessionStorage.setItem("token", token);
                store.commit(types.SET_TOKEN, token);
            } else {
                Toast.fail("未获取到token,请联系信息中心");
                return
            }
            // actions.saveToken(token)
        }).catch(err => {
            Toast.fail(err + "请联系信息中心");
        });
    }

}
export default token;


// WEBPACK FOOTER //
// ./src/axios/token.js